<template>
  <!-- 团险活动 -->
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_01.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_02.jpg" />
      <div class="rule-icon" @click="$refs.rulesRef.open()"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_03.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_04.jpg" />
      <div class="detaile" @click="detailPage(0)"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_05.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_06.jpg" />
      <div class="product-btn" @click="productPage(134003)"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_07.jpg" />
      <div class="product-btn" @click="productPage(12601)"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202409/04/p_08.jpg" />
      <div class="product-btn" @click="productPage(79096)"></div>
    </div>
    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>
  </div>
</template>

<script>
import config from '@/api/common';
import activityRules from '@/components/okActivity/rulePopup';

export default {
  components: {
    activityRules
  },
  data() {
    return {
      activityIds: [],
      activityList: [],
      preview: false,
      ruleText:
        '<h1 style="text-align:center;font-size: 22px;">规则详情</h1><h2 style="margin-top: 10px;">一、活动时间：</h2><p>2024年9月1日——2024年9月30日</p><p><br/></p><h2><span>二、活动对象：</span></h2><p><span>OK保已签约代理人</span></p><h2><span>三、活动须知：</span></h2><p><span>出单OK保团险产品且保费满足要求</span></p><p><span>&nbsp;</span></p><p><span>四、单单有奖</span></p><p><span>（一）活动内容</span></p><p><span>1、活动期间内出单任意团险产品，且每单保费大于或等于2000元，按照单数计算，每出一单（不含保全，仅限新单），奖励30元现金，多出多得。</span></p><p><span>&nbsp;</span></p><p><span>（二）注意事项</span></p><p><span>1、奖励仅针对活动期间活动产品新单保费，保全不参与</span></p><p><span>2、严禁恶意拆单，若发现多笔订单均为同一企业、同一出单人、同一产品，则视为同一个订单，仅发放一次奖励。</span></p><p><span>&nbsp;</span></p><p><span>五、</span><span>限时现金奖励活动</span></p><p><span>&nbsp;</span></p><p><span>（一）活动内容</span></p><p><span>1、融盛团体意外险、桐星保雇主责任险、华安“装修无忧”建筑工程施工人员团体人身意外伤害保险；</span><span>奖励仅针对活动期间（以上指定3款产品）新单保费，单笔保费达到2W或2W以上（不含保全，仅限新单）可以获得188元的现金奖励，保全不参与。</span></p><p><span>&nbsp;</span></p><p><span>（二）注意事项</span></p><p><span>2、若发现多笔订单均为同一企业、同一出单人、同一产品，则视为同一个订单，仅发放一次奖励。</span></p><p><span>&nbsp;</span></p><p><span>六、活动规则</span></p><p><span>1、如遇退保，OK保将扣回此单所有推广费及所有活动奖励。如发现同一代理人活动期间退保率或批减至最低承保人数超过2%，OK保有权追回所有奖励。</span></p><p><span>2、活动订单仅计算活动期间所出新单，保全不参与。</span></p><p><span>3、参加活动要求个人历史退保率&lt;2%，达标与否，将以活动开始前定版数据(即2024年8月31日零点系统数据)为准。</span></p><p><span>4、代理人若在奖励发放前离职或停职、账号已注销，则奖励不予结算。</span></p><p><span>&nbsp;</span></p><p><span>七、活动奖励发放</span></p><p><span>1、奖励将会在活动结束后的次月20日之后进行发放。产生退保的订单奖励不予结算。领取途径：进入APP我的页面——点击可提现——提现到银行卡。</span></p><p><span>2、退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行活动奖励发放。</span></p><p><span>&nbsp;</span></p><p><span>八、活动参与资格、获奖资格的取消</span></p><p><span>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</span></p><p><span>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</span></p><p><span>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</span></p><p><span>3、违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</span></p><p><span>&nbsp;</span></p><p><span>九、免责条款</span></p><p><span>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</span></p><p><span>&nbsp;</span></p><p><span>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</span></p><p><br></p>'
    };
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;
    // 地址栏配置id
    let ids = this.$route.query.ids;
    if (ids) {
      this.activityIds = ids.split(',');
    } else if (config.env == '0' || config.env == '2') {
      // 本地、测试
      this.activityIds = ['1816314683121459201'];
    } else {
      // 正式
      this.activityIds = ['1829039074286280706','1829052441016848386'];
    }
    this.getList();
  },

  methods: {
    // 获取活动详情
    getList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: this.activityIds.join(',')
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },
    // 跳转产品详情
    productPage(productCode) {
      if (this.$route.query.preview) return;
      const userinfo = JSON.parse(localStorage.jzy_user);
      const url = this.$config.productBase + `/m/product/app/detail/groupInsurance?userId=${userinfo.userId}&productCode=${productCode}`;
      location.href = url;
    },

    // 明细
    detailPage(index) {
      if (this.$route.query.preview) return;
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: this.activityIds[index],
          type: this.activityList[index].type,
          calFactor: this.activityList[index].calFactor,
          productType: this.activityList[index].productType,
          mode: this.activityList[index].mode,
          status: this.activityList[index].status,
          conditionalIndicator: this.activityList[index].conditionalIndicator,
          activityType: 'group'
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .rule-icon {
      width: 150px;
      height: 100%;
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .detail-icon {
      width: 64px;
      height: 64px;
      position: absolute;
      right: 20px;
      bottom: 0;
    }
    .detaile {
      width: 500px;
      height: 102px;
      position: absolute;
      bottom: 30px;
      left: 50%;
      margin-left: -250px;
      border-radius: 51px;
    }
    .product-btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
